export default __webpack_public_path__ + "static/media/nomination-back.d571ed30.png";